import { render, staticRenderFns } from "./DocFormatCallback.vue?vue&type=template&id=0b2c61e7&"
import script from "./DocFormatCallback.vue?vue&type=script&lang=ts&"
export * from "./DocFormatCallback.vue?vue&type=script&lang=ts&"
import style0 from "./DocFormatCallback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports